import { render, staticRenderFns } from "./view_Lion.vue?vue&type=template&id=a29974d2&"
import script from "./view_Lion.vue?vue&type=script&lang=js&"
export * from "./view_Lion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports